import { Images } from '../../../images'

// Svg images do not work with the react-component-export-image library used to export receipt copies
export const organizationLogoMap: { [key: string]: string } = {
  coles: Images.colesLogo,
  woolworths: Images.woolworthsLogo,
  'Euroshop 2020': Images.temporaryEuroshopVoucherLogo,
  default: Images.tomraLogo
}
